// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__3-r5+","title":"PageHeader_title__pRoV8","subtitle":"PageHeader_subtitle__xg6ur","headerCompact":"PageHeader_headerCompact__Dmmrc"};